import { render } from "./freeShare.vue?vue&type=template&id=59361b52"
import script from "./freeShare.vue?vue&type=script&lang=ts"
export * from "./freeShare.vue?vue&type=script&lang=ts"

import "./freeShare.vue?vue&type=style&index=0&id=59361b52&lang=scss"
script.render = render

export default script